export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBup6RLQEYGR4pIoj-Iffl5jWxg0EHSAfo",
    authDomain: "vastmove-a9dcf.firebaseapp.com",
    projectId: "vastmove-a9dcf",
    storageBucket: "vastmove-a9dcf.appspot.com",
    messagingSenderId: "142870833268",
    appId: "1:142870833268:web:1af7662cd3101f0e208921",
    measurementId: "G-SZDQSB9N2Z"
  },
  //appUrl: 'http://histodevapi.expertapps.com.sa', // TEST ONE URL
  //apiUrl: 'http://histodevapi.expertapps.com.sa/api', // TEST API front
  //signalR: 'http://histodevapi.expertapps.com.sa/hubs', // TEST SignalR
  
  apiUsr: 'https://vmapiusr.azurewebsites.net/api', // API User
  apiStock: 'https://vmapistock.azurewebsites.net/api', // API Stock
  apiWfl: 'https://vmapiwfl.azurewebsites.net/api', // API WFL
  apiWhs: 'https://vmapiwhs.azurewebsites.net/api', // API WHS
  apiAcc: 'https://vmapiacc.azurewebsites.net/api', // API Acc
  apiReports: 'https://vmapireports.azurewebsites.net/api', // API Reports
  //appUrl: 'http://localhost:12345', // Local URL
  appUrl: 'https://vastmovedemo.azurewebsites.net/' // Prod URL
};
